let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQxvn")).then(() => parcelRequire('fDHwb'));